<template>
  <v-row>
    <v-col
      v-for="(item, index) in banners"
      :key="index"
      cols="12" sm="6" md="3" lg="6"
    >
      <c-item :item="item"/>
    </v-col>
  </v-row>
</template>

<script>
import CItem from './CItem'

export default {
  name: 'CBanners',
  components: {
    CItem
  },
  props: {
    banners: {
      type: Array,
      required: true
    }
  }
}
</script>
